import {isNil, sortBy} from 'ramda';

import type {FinancingEndingBulkOperationItemResponseBody} from '@dms/api/sales';

import {
  FINANCING_ENDING_OPERATION_ITEM_RESULT,
  type FinancingEndingOperationItemResult,
} from '../constants/FINANCING_ENDING_OPERATION_ITEM_RESULT';
import {getFinancingEndingOperationItemReason} from './getFinancingEndingOperationItemReason';
import {getFinancingEndingOperationItemResult} from './getFinancingEndingOperationItemResult';

const RESULT_ORDER: FinancingEndingOperationItemResult[] = Object.values(
  FINANCING_ENDING_OPERATION_ITEM_RESULT
);

const getResultRank = (result: FinancingEndingOperationItemResult | null) =>
  isNil(result) ? RESULT_ORDER.length : RESULT_ORDER.indexOf(result);

/**
 * The items with their result and reason, problems first, then pending and sent; rows without a
 * known result come last. Rows of one result keep their order.
 */
export const getFinancingEndingOperationItemRows = (
  items: FinancingEndingBulkOperationItemResponseBody[]
) =>
  sortBy(
    (row) => getResultRank(row.result),
    items.map((item) => {
      const result = getFinancingEndingOperationItemResult(item);
      return {item, result, reason: getFinancingEndingOperationItemReason(item, result)};
    })
  );

export type FinancingEndingOperationItemRow = ReturnType<
  typeof getFinancingEndingOperationItemRows
>[number];
